const PUNCTUATION_REPLACEMENTS: Readonly<Record<string, string>> = {
  '，': ',',
  '。': '.',
  '；': ';',
  '：': ':',
  '！': '!',
  '？': '?',
  '（': '(',
  '）': ')',
  '【': '[',
  '】': ']',
  '［': '[',
  '］': ']',
  '｛': '{',
  '｝': '}',
  '“': '"',
  '”': '"',
  '‘': "'",
  '’': "'",
  '、': ',',
  '‐': '-',
  '‑': '-',
  '‒': '-',
  '–': '-',
  '—': '-',
  '−': '-',
}

/**
 * Produces a comparison-only text value. Original cell values must be retained
 * separately for display and reports.
 */
export function normalizeText(value: unknown): string {
  if (value === null || value === undefined) return ''

  const text =
    typeof value === 'string' || typeof value === 'number' || typeof value === 'bigint'
      ? String(value)
      : ''

  return Array.from(text.normalize('NFKC'))
    .map((character) => PUNCTUATION_REPLACEMENTS[character] ?? character)
    .join('')
    .replace(/[\s\u00a0\u3000]+/gu, ' ')
    .trim()
    .toLocaleLowerCase('zh-CN')
}

export function normalizeHeaderText(value: unknown): string {
  return normalizeText(value).replace(/[\s,.;:!?()[\]{}'"/\\_-]+/gu, '')
}
